<template>
  <v-card class="mb-4"
          v-if="team.content_enabled">
    <v-card-title>
      Other Settings
    </v-card-title>
    <v-simple-table>
      <tbody>
      <tr>
        <td>
          iOS Settings
        </td>
      </tr>
      <tr>
        <td>
          PDF View Mode
        </td>
      </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  props: {
    presentation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ])
  }
}
</script>
